// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"30ce6eea","101":"ef01e407","303":"ef01e407","359":"ef01e407","615":"ef01e407"}[chunkId] + ".chunk.css";
};